import { Component, Inject } from '@angular/core';
import { MatSnackBar, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'sibat-html-notification',
  templateUrl: './html-notification.component.html',
  styleUrls: ['./html-notification.component.scss'],
  imports: [MatButton],
})
export class HtmlNotificationComponent {
  readonly htmlMessage = this.data.htmlMessage;

  constructor(@Inject(MAT_SNACK_BAR_DATA) private data: { htmlMessage: string }, readonly snackBar: MatSnackBar) {}
}
